import {
  Row,
  Col,
  Container,
  Form,
  Button,
  CloseButton,
  InputGroup,
  Table,
  Alert,
  Card
} from "react-bootstrap";
import MaskedInput from 'react-text-mask';
import { Link } from "react-router-dom";
import React, { useState, useRef, useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import GoBackButton from "./GoBackButton";

const CreateUserPageComponent = ({
  createUserApiRequest,
  getAllUniformRole,
  getAlldeliveryBooks,
  getUniformRoleByRole,
  createUniformUserRole
}) => {
  const [accountType, setAccountType] = useState("Business");
  const [validated, setValidated] = useState(false);
  const [password, setPassword] = useState("");
  const [allUniformRoles, setAllUniformRoles] = useState([]);
  const [selectedRole, setSelectedRole] = useState("");
  const [deliveryBookData, setDeliveryBookData] = useState([]);
  const [userSites, setUserSites] = useState([])
  const [selectedSites, setSelectedSites] = useState({})
  const [userCompany, setUserCompany] = useState("")
  const [userLocation, setUserLocation] = useState("")
  const [userRole, setUserRole] = useState("")
  const [otherRole, setOtherRole] = useState("");
  const [abnNum, setAbnNum] = useState("")
  const [contacted, setContacted] = useState(false)
  const [isCreditVerified, setIsCreditVerified] = useState(false);
  const [updateUserResponseState, setUpdateUserResponseState] = useState({
    message: "",
    error: "",
  });
  const emailRef = useRef();
  const navigate = useNavigate();
  const abnMask = [/\d/, /\d/, ' ', /\d/, /\d/, /\d/, ' ', /\d/, /\d/, /\d/, ' ', /\d/, /\d/, /\d/]


  const [isAdmin, setIsAdmin] = useState(false);
  const [isPD, setIsPD] = useState(false);
  const [isSiteManager, setIsSiteManager] = useState(false);
  const [isSitePerson, setIsSitePerson] = useState(false);
  const [verified, setVerified] = useState(false);
  const [isSales, setIsSales] = useState(false);
  const [isMarketing, setIsMarketing] = useState(false);
  const [isDeveloper, setIsDeveloper] = useState(false);
  const [accounts, setAccounts] = useState(false);
  const [isSuperAdmin, setIsSuperAdmin] = useState(false);
  const [isExtSales, setIsExtSales] = useState(false);
  const [isVIP, setIsVIP] = useState(false);
  const [show, setShow] = useState(false);
  // const [showAbn, setShowAbn] = useState(false);
  const [showLocation, setShowLocation] = useState(false)

  useEffect(() => {
    getAllUniformRole()
      .then((data) => {
        const updatedRoles = data.filter(role => role.role !== "Other Role");
        setAllUniformRoles(updatedRoles)
        if (updatedRoles.length > 0) {
          setSelectedRole(updatedRoles[0].role);
          setUserRole(updatedRoles[0].role);
        }
      })
      .catch((er) => console.log(er));
  }, []);

  useEffect(() => {
    getAlldeliveryBooks().then((data) => {
      setDeliveryBookData(data);
      const userSitesData = data.map(company => ({
        company: company.companyName,
        sites: company.sites.map(site => site.name),
        abn: company.abn || "",
        emailHost: company.emailHost
      }))
      setUserSites(userSitesData)
    })
  }, [])

  const setUserDetails = (emailHost) => {
    const emailDomain = emailHost.toLowerCase();
    const userCompany = userSites.find((site) => {
      const allowedDomains = site.emailHost.toLowerCase().split('/');
      return allowedDomains.some((domain) => emailDomain.endsWith(domain));
    });

    if (userCompany) {
      setUserCompany(userCompany.company);
      setSelectedSites(userCompany);
      setUserLocation(userCompany.sites[0]);
      setAbnNum(userCompany.abn || "No ABN");
    } else {
      setUserCompany("No Company");
      setUserLocation("No Site");
      setUserRole("No Role");
      setShow(false);
      setShowLocation(false);
      // if (accountType === "Personal")
      //   setShowAbn(false);
      // else
      //   setShowAbn(true)
      setAbnNum("No abn");
    }
  };

  const handleEmail = (e) => {
    //selectedSites.length = 0
    const email = e.target.value
    if (email === "" || email === null) {
      setShow(false);
      setShowLocation(false);
      // setShowAbn(false)
    } else {
      var mailformat = /^\w+([\.-]?\w+)*@\w+([\.-]?\w+)*(\.\w{2,3})+$/;
      if (!email.match(mailformat)) {
        alert("Invalid email format")
      } else {
        setShow(true);
        // setShowAbn(false);
        const emailHost = email.split("@")[1];
        const tempCompany = emailHost.split(".")[0];
        setUserDetails(emailHost);
      }
    }
  };

  const handleAbn = (e) => {
    const newValue = e.target.value;
    setAbnNum(newValue);
  };

  const handleOtherRole = (e) => {
    setOtherRole(e.target.value);
  }

  const handleChangeRole = (e) => {
    setSelectedRole(e.target.value);
    setUserRole(e.target.value)
  }

  const handleChangeLocation = (e) => {
    setUserLocation(e.target.value)
  }

  const toTitleCase = (str) => {
    return str
      .toLowerCase()
      .split(" ")
      .filter(word => word.trim().length > 0)   // remove empty spaces
      .map(word => word.charAt(0).toUpperCase() + word.slice(1))
      .join(" ");
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    event.stopPropagation();

    const form = event.currentTarget.elements;
    // const accountType = accountType;
    const name = form.name.value;
    const lastName = form.lastName.value;
    const email = form.email.value;
    const password = form.password.value;
    const abn = form.abn.value;
    const phone = form.phone.value;
    const mobile = form.mobile.value;
    const company = form.company.value;
    const location = form.location.value;
    let ipAddress = "";
    const role = userRole === "Other Role" ? otherRole : userRole;
    let isNewUser = true;
    const contactedDate = form.contactedDate.value;
    const notes = form.notes.value;

    if (ipAddress === "remove") {
      ipAddress = "";
    }
    const formIsValid = event.currentTarget.checkValidity() === true;
    setValidated(true);
    if (!formIsValid) return;

    try {
      const data = await createUserApiRequest(
        // accountType,
        name,
        lastName,
        email,
        password,
        phone,
        mobile,
        ipAddress,
        isAdmin,
        verified,
        isPD,
        isSiteManager,
        isSitePerson,
        company,
        location,
        isSales,
        isMarketing,
        isDeveloper,
        isSuperAdmin,
        isExtSales,
        isNewUser,
        isVIP,
        isCreditVerified,
        accounts,
        abn,
        role,
        contacted,
        contactedDate,
        notes
      );
      console.log(data);

      if (data.success === "User Created") {
        if (userRole === "Other Role") {
          const formattedRole = toTitleCase(role);
          try {
            await getUniformRoleByRole(formattedRole);
            alert("Role already exists");
            return;

          } catch (err) {
            if (err.response && err.response.status === 404) {
              const Rdata = await createUniformUserRole(formattedRole);
              if (Rdata?.message !== "uniform role created") {
                throw new Error("Failed to create uniform role. Please try again.");
              } else {
                navigate("/admin/users");
              }
            } else {
              throw err;
            }
          }
        }
        navigate("/admin/users");
      }
    } catch (er) {
      setUpdateUserResponseState({
        error: er?.response?.data?.message
          ? er.response.data.message
          : er?.response?.data || "Something went wrong",
      });
    }
  }

  return (
    <Container>
      <Row className="justify-content-md-center mt-5 content-container">
        <Col md={1}>
          <GoBackButton />
        </Col>
        <Col md={6}>
          <h1>Create User</h1>
          <Form noValidate validated={validated} onSubmit={handleSubmit}>
            <Form.Group className="mb-3" controlId="formBasicFirstName">
              <Form.Label>First name</Form.Label>
              <Form.Control
                name="name"
                required
                type="text"
              />
            </Form.Group>

            <Form.Group className="mb-3" controlId="formBasicLastName">
              <Form.Label>Last name</Form.Label>
              <Form.Control
                name="lastName"
                required
                type="text"
              />
            </Form.Group>

            <Form.Group className="mb-3" controlId="formBasicEmail">
              <Form.Label>Email</Form.Label>
              <InputGroup hasValidation>
                <Form.Control
                  type="text"
                  name="email"
                  placeholder="Email"
                  aria-describedby="inputGroupPrepend"
                  onBlur={handleEmail}
                  required
                  ref={emailRef}
                />
                <Form.Control.Feedback type="invalid">
                  Please enter a valid email.{" "}
                </Form.Control.Feedback>
              </InputGroup>
            </Form.Group>

            <Form.Group className="mb-3" controlId="formBasicPassword">
              <Form.Label>Password</Form.Label>
              <Form.Control
                type="text"
                name="password"
                placeholder="Password"
                aria-describedby="inputGroupPrepend"
                required
              />
              <Form.Control.Feedback type="invalid">
                Please enter a Password.{" "}
              </Form.Control.Feedback>
            </Form.Group>

            {show ? (
              <>
                <Row className="mb-3" >
                  <Form.Group as={Col} md="6" controlId="formBasicCompany">
                    <Form.Label>Company</Form.Label>
                    <InputGroup hasValidation>
                      <Form.Control
                        type="text"
                        name="company"
                        placeholder="Company"
                        value={userCompany}
                        aria-describedby="inputGroupPrepend"
                        required
                        disabled
                      />
                      <Form.Control.Feedback type="invalid">
                        Please mention company name.{" "}
                      </Form.Control.Feedback>
                    </InputGroup>
                  </Form.Group>

                  <Form.Group as={Col} md="6" controlId="formBasicLocation">
                    <Form.Label>Location</Form.Label>
                    <Form.Select
                      required
                      name="location"
                      onChange={handleChangeLocation}
                      style={{ textTransform: "capitalize" }}
                    >
                      <option>--Select Site--</option>
                      {
                        selectedSites.sites?.map((site, idx) => (
                          < option key={idx} value={site} style={{ textTransform: "capitalize" }}>
                            {site.toLowerCase()}
                          </option>))
                      }
                    </Form.Select>
                  </Form.Group>
                </Row>
              </>
            ) : (
              <>
                <Row className="mb-3" >
                  <Form.Group as={Col} md="6" controlId="formBasicCompany">
                    <Form.Label>Company</Form.Label>
                    <InputGroup hasValidation>
                      <Form.Control
                        type="text"
                        name="company"
                        placeholder="Company"
                        aria-describedby="inputGroupPrepend"
                        required
                      />
                      <Form.Control.Feedback type="invalid">
                        Please mention company name.{" "}
                      </Form.Control.Feedback>
                    </InputGroup>
                  </Form.Group>

                  <Form.Group as={Col} md="6" controlId="formBasicLocation">
                    <Form.Label>Location</Form.Label>
                    <InputGroup hasValidation>
                      <Form.Control
                        type="text"
                        name="location"
                        placeholder="Location"
                        aria-describedby="inputGroupPrepend"
                        required
                      />
                      <Form.Control.Feedback type="invalid">
                        Please mention Location name.{" "}
                      </Form.Control.Feedback>
                    </InputGroup>
                  </Form.Group>
                </Row>
              </>
            )}

            <Form.Group className="mb-3" controlId="formBasicRole">
              <Form.Label>Role</Form.Label>
              <Form.Select
                required
                name="role"
                value={selectedRole}
                onChange={handleChangeRole}
              >
                {
                  allUniformRoles.map((role, idx) => (
                    <option key={idx} value={role.role} style={{ textTransform: "capitalize" }}>
                      {role.role}
                    </option>))
                }
                <option key="other role">
                  Other Role
                </option>
              </Form.Select>
              <Form.Control.Feedback type="invalid">
                Please Select your Role.{" "}
              </Form.Control.Feedback>
            </Form.Group>
            {userRole === "Other Role" && <Form.Group className="mb-3" controlId="formBasicOtherRole">
              <Form.Label>User Role</Form.Label>
              <Form.Control
                required
                type="text"
                name="otherRole"
                placeholder="Add role here. This role will be added to the main Roles list."
                onChange={handleOtherRole}
                value={otherRole}
                style={{ backgroundColor: "#e6f2ff" }}
              />
              <Form.Control.Feedback type="invalid">
                Please mention your Job Title.{" "}
              </Form.Control.Feedback>
            </Form.Group>}

            <Form.Group className="mb-3" controlId="formBasicAbn">
              <Form.Label>ABN</Form.Label>
              <MaskedInput
                mask={abnMask}
                placeholder="ABN"
                guide={false}
                value={abnNum}
                onChange={handleAbn}
                render={(ref, props) => <Form.Control
                  // required
                  minLength={14}
                  maxLength={14}
                  type="text"
                  name="abn"
                  ref={ref}
                  {...props}
                />}
              />
            </Form.Group>

            <Form.Group className="mb-2" controlId="formBasicPhone">
              <Form.Label>Phone</Form.Label>
              <Form.Control
                name="phone"
                required
                type="number"
              />
            </Form.Group>
            <Form.Group className="mb-2" controlId="formBasicMobile">
              <Form.Label>Mobile</Form.Label>
              <Form.Control
                name="mobile"
                required
                type="number"
              />
            </Form.Group>

            {/* <Form.Group className="mb-3" controlId="formBasicDeliveryCompany">
              <Form.Label>Company</Form.Label>
              <Form.Control
                name="company"
                required
                type="txt"
              />
            </Form.Group>

            <Form.Group className="mb-3" controlId="formBasicBillLocation">
              <Form.Label>Location</Form.Label>
              <Form.Control
                name="location"
                required
                type="txt"
              />
            </Form.Group> */}

            <Form.Group className="mb-3" controlId="formBasicIsAdmin">
              <Row>
                <Col md={2}>
                  <Form.Check
                    name="verified"
                    type="checkbox"
                    label="Verified"
                    checked={verified}
                    onChange={(e) => setVerified(e.target.checked)}
                  />
                </Col>
              </Row>
              <Row>
                <Col md={3}>
                  <Form.Check
                    name="contacted"
                    type="checkbox"
                    label="Contacted"
                    checked={contacted}
                    onChange={(e) => setContacted(e.target.checked)}
                  />
                </Col>
                <Col md={4}>
                  <Form.Label>Contacted Date</Form.Label>
                  <Form.Control
                    name="contactedDate"
                    type="date"
                    label="Contacted Date"
                    disabled={!contacted}
                  />
                </Col>
              </Row>
              <Row>
                <Col md={12}>
                  <Form.Label>Notes</Form.Label>
                  <Form.Control
                    name="notes"
                    as="textarea"
                    rows={4}
                    label="Notes"
                    disabled={!contacted}
                  />
                </Col>
              </Row>
              <Row>
                <Col md={2}>
                  <Form.Check
                    name="isAdmin"
                    type="checkbox"
                    label="Admin"
                    checked={isAdmin}
                    onChange={(e) => setIsAdmin(e.target.checked)}
                  />
                </Col>
                <Col md={2}>
                  <Form.Check
                    name="isPD"
                    type="checkbox"
                    label="PD"
                    checked={isPD}
                    onChange={(e) => setIsPD(e.target.checked)}
                  />
                </Col>
                <Col md={3}>
                  <Form.Check
                    name="isSiteManager"
                    type="checkbox"
                    label="Site Manager"
                    checked={isSiteManager}
                    onChange={(e) => setIsSiteManager(e.target.checked)}
                  />
                </Col>
                <Col md={3}>
                  <Form.Check
                    name="isSitePerson"
                    type="checkbox"
                    label="Site Person"
                    checked={isSitePerson}
                    onChange={(e) => setIsSitePerson(e.target.checked)}
                  />
                </Col>
              </Row>
              <Row>
                <Col md={2}>
                  <Form.Check
                    name="isVIP"
                    type="checkbox"
                    label="isVIP"
                    checked={isVIP}
                    onChange={(e) => setIsVIP(e.target.checked)}
                  />
                </Col>
                <Col md={2}>
                  <Form.Check
                    name="isCreditVerified"
                    type="checkbox"
                    label="isCreditVerified"
                    checked={isCreditVerified}
                    onChange={(e) => setIsCreditVerified(e.target.checked)}
                  />
                </Col>
              </Row>
            </Form.Group>

            <Form.Group className="mb-3" controlId="formBasicAdminAccess">
              <Row>
                <Col md={2}>
                  <Form.Check
                    name="isSales"
                    type="checkbox"
                    label="Sales"
                    checked={isSales}
                    onChange={(e) => setIsSales(e.target.checked)}
                  />
                </Col>
                <Col md={2}>
                  <Form.Check
                    name="accounts"
                    type="checkbox"
                    label="Accounts"
                    checked={accounts}
                    onChange={(e) => setAccounts(e.target.checked)}
                  />
                </Col>
                <Col md={2}>
                  <Form.Check
                    name="isDeveloper"
                    type="checkbox"
                    label="Developer"
                    checked={isDeveloper}
                    onChange={(e) => setIsDeveloper(e.target.checked)}
                  />
                </Col>
                <Col md={3}>
                  <Form.Check
                    name="isMarketing"
                    type="checkbox"
                    label="Marketing"
                    checked={isMarketing}
                    onChange={(e) => setIsMarketing(e.target.checked)}
                  />
                </Col>
                <Col md={3}>
                  <Form.Check
                    name="isSuperAdmin"
                    type="checkbox"
                    label="Super Admin"
                    checked={isSuperAdmin}
                    onChange={(e) => setIsSuperAdmin(e.target.checked)}
                  />
                </Col>
                <Col md={3}>
                  <Form.Check
                    name="isExtSales"
                    type="checkbox"
                    label="Ext Sales"
                    checked={isExtSales}
                    onChange={(e) => setIsExtSales(e.target.checked)}
                  />
                </Col>
              </Row>
            </Form.Group>

            {/* <Form.Group className="mb-3" controlId="formBasicVerified">
              
            </Form.Group> */}

            <Button variant="primary" type="submit">
              CREATE
            </Button>
            {updateUserResponseState.error}
          </Form>
        </Col>
      </Row>
    </Container>
  );
};

export default CreateUserPageComponent;
